import React, { useEffect, useState } from "react";
import { floorStatus } from "../lib/api";
import { ProfitLockControl } from "./ProfitLockControl";

// Main-page strip: floor gates + the owner's Profit Lock control (toggle, $ lock, live day net, state badge).
export const FloorLockStrip = () => {
  const [g, setG] = useState(null);
  useEffect(() => {
    const load = () => floorStatus().then((d) => setG(d.gates)).catch(() => {});
    load(); const t = setInterval(load, 60000); return () => clearInterval(t);
  }, []);
  return (
    <div data-testid="floor-lock-strip" className="px-3 py-2 border-b border-[#00F0FF14] bg-[#050a16] space-y-1.5">
      {g && (
        <p data-testid="main-gates-line" className="text-[11px] font-mono tracking-wide text-[#00F0FF]/80">
          long gate {g.long} · momentum gate {g.momentum} · short gate {g.short}
        </p>)}
      <ProfitLockControl />
    </div>
  );
};
